/*
 *
 * TutorialTour reducer
 *
 */

import ActionTypes from './constants';
import { ContainerActions, ContainerState } from './types';

export const initialState: ContainerState = {
  isOpen: false,
  step: 0,
};

function tutorialTourReducer(
  state: ContainerState = initialState,
  action: ContainerActions,
): ContainerState {
  switch (action.type) {
    case ActionTypes.DISPLAY_TUTORIAL:
      return { ...state, isOpen: action.payload.isOpen };
    case ActionTypes.GO_TO_STEP_TUTORIAL:
      return { ...state, step: action.payload.stepNumber };
    // case ActionTypes.GO_TO_STEP_TUTORIAL:
    //   if (state.step + 1 < tutorialSteps.length)
    //     return { ...state, step: state.step + 1 };
    //   else {
    //     return { ...state, step: 0 };
    //   }
    default:
      return state;
  }
}

export default tutorialTourReducer;
